import { UserRole } from "@/types/users";
import { defineStore } from "pinia";
const CONTEXT_PATH = "/context";
export const useContext = defineStore("context", {
    state: () => ({
        primaryDomain: "",
        resourceTimestamp: "",
        siteDefaultLocale: "",
        currentLocale: "",
        supportedLocales: [],
        preferredLocales: [],
        role: UserRole.USER,
        isUnrestricted: false,
        currentStudyId: undefined,
        viewProfiles: {}
    }),
    getters: {
        currentLocaleJavaScript: ({ currentLocale }) => currentLocale.replaceAll("_", "-"),
        isAnalyst(state) {
            return state.role == UserRole.SUPER_ADMIN || state.role == UserRole.ANALYST;
        },
        isModerator(state) {
            return state.role == UserRole.MODERATOR || this.isAnalyst;
        },
        isAdmin(state) {
            return state.role == UserRole.CLIENT || this.isModerator;
        },
        isSuperAdmin(state) {
            return state.role == UserRole.SUPER_ADMIN;
        }
    },
    actions: {
        onLoad(context) {
            this.primaryDomain = context.primaryDomain;
            this.resourceTimestamp = context.resourceTimestamp;
            this.siteDefaultLocale = context.siteDefaultLocale;
            this.currentLocale = context.currentLocale;
            this.supportedLocales = context.supportedLocales;
            this.preferredLocales = context.preferredLocales;
            this.role = context.role;
            this.isUnrestricted = context.isUnrestricted;
            this.currentStudyId = context.currentStudyId;
            this.viewProfiles = context.viewProfiles;
            return context;
        },
        load() {
            console.error("Context data could not be loaded from page.");
            return Promise.resolve({});
        },
        toAbsolutePath(path) {
            return `${window.location.protocol}//${this.primaryDomain}/${path.replace(/^\//, "")}`;
        }
    },
    loadable: {
        action: "load",
        reloadable: true,
        autoload: true,
        fromPage: {
            key: CONTEXT_PATH,
            onLoad: "onLoad"
        }
    }
});
